import { Component } from '@angular/core';

@Component({
  selector: 'app-reference-scheme-router',
  templateUrl: './reference-scheme-router.component.html',
  standalone: false,
})
export class ReferenceSchemeRouterComponent {
  constructor() {}
}
